import { apiClient } from './client.js'

export async function fetchAssetSignedUrl(assetId) {
  const { data } = await apiClient.get(`/files/${assetId}/signed-url`)
  return data
}

export async function requestUploadUrl({ floor_id, asset_type, file_name, mime, size }) {
  const { data } = await apiClient.post(
    '/uploads/sign',
    { floor_id, asset_type, file_name, mime, size },
    { timeout: 60_000 },
  )
  return data
}

export async function confirmUpload({ pending_id, storage_key, checksum, size }) {
  const { data } = await apiClient.post(
    '/uploads/confirm',
    { pending_id, storage_key, checksum, size },
    { timeout: 60_000 },
  )
  return data
}
